import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = o((e, r) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4182",
              width: 32,
              height: 32,
              x: 8,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M32.36 13.7c-2.12 0-3.2.82-4.07 1.47-.68.51-1.17.88-2.06.88-1.1 0-1.41-1.21-1.49-1.94-.22-1.88.36-2.99.9-3.59.57-.65 1.39-1.03 2.18-1.03.41 0 .75-.34.75-.75S28.23 8 27.82 8c-1.21 0-2.45.57-3.3 1.53-.74.83-1.55 2.33-1.26 4.76.24 2.04 1.36 3.26 2.98 3.26 1.4 0 2.23-.63 2.97-1.19.8-.6 1.55-1.17 3.16-1.17 2.29 0 6.14.93 6.14 7.17 0 7.25-4.3 16.11-9.32 16.11-2.17 0-2.92-.57-3.52-1.03-.42-.32-.9-.69-1.65-.69-.76 0-1.22.37-1.62.7-.57.46-1.29 1.04-3.54 1.04-5.71 0-9.35-9.71-9.35-16.39-.01-4.25 2.54-7 6.49-7 1.33 0 2 .52 2.79 1.12.66.5 1.4 1.08 2.53 1.32.41.08.8-.17.89-.57.09-.41-.17-.8-.57-.89-.8-.18-1.33-.58-1.94-1.05-.87-.67-1.86-1.43-3.7-1.43-4.79 0-8 3.42-8 8.51C8 29.58 12.13 40 18.85 40c2.78 0 3.81-.83 4.48-1.38.36-.29.47-.36.68-.36.22 0 .36.09.74.38.7.53 1.75 1.34 4.43 1.34 6.6 0 10.82-10.43 10.82-17.61 0-5.43-2.85-8.67-7.64-8.67"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4182)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyLunchIcon";
export {
  i as AgencyLunchIcon,
  i as default
};
//# sourceMappingURL=index.js.map
